<template>
  <div class="icon">
    <svg class="icon_svg" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 70.402 70.402">
      <g id="Group_321" data-name="Group 321" transform="translate(-1588.653 -947.181)">
        <circle id="Ellipse_74" data-name="Ellipse 74" cx="35.201" cy="35.201" r="35.201" transform="translate(1588.653 947.181)" :class="['svg-fill--' + color]" />
        <g id="Group_91" data-name="Group 91">
          <path id="Path_217" data-name="Path 217" d="M1640.421,1000.106h-2.82V966.263h1.41v-4.231h-31.023v4.231h1.41v33.843h-2.115a.7.7,0,0,0,0,1.41h17.627V986.005h9.871v15.511h5.64a.7.7,0,0,0,0-1.41Zm-18.331-14.1v5.64h-9.871v-5.64Zm0-8.461v5.64h-9.871v-5.64Zm0-8.461v5.641h-9.871v-5.641Zm12.691,8.461v5.64h-9.871v-5.64Zm0-8.461v5.641h-9.871v-5.641Z" fill="#fff"/>
        </g>
      </g>
    </svg>

  </div>
</template>

<script>
export default {
  name: 'red-icon',
  props: ['color']
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';

  .icon{
    display: flex; -js-display: flex;
    height: 100%;
    align-items: center;
  }

  .icon_svg{
    flex: 0 0 30px;
    height: 30px;
    width: 30px;
  }

  .cls-2{fill: $gray-lightest;}

</style>



// WEBPACK FOOTER //
// src/components/shared/navigation/AttributesNavigation/assets/ImpartialAdministrationIcon.vue